const GenerationType = {
  OUTLINE: 'outline',
  BOOK_SAMPLE: 'bookSample',
  STYLE_SAMPLES: 'styleSamples',
  DRAFT: 'draft',
  DEDICATION: 'dedication',
  TITLE_IDEAS: 'titleIdeas',
};

module.exports = GenerationType;
